/* eslint-disable react/jsx-closing-tag-location */
/* eslint-disable react/jsx-closing-bracket-location */
import React from "react";
import { withStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Card from "@material-ui/core/Card";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import Button from "@material-ui/core/Button";
import Paper from "@material-ui/core/Paper";
import Fab from "@material-ui/core/Fab";
import { withTranslation } from "react-i18next";
import MobileFooter from "../../Common/Profile/MobileFooter";

import Loader from "../../Common/Loader";
import { commonStyleForEditPersonalInfo } from "../../Common/CommonStyle";
import PageHeaderTitle from "../../Common/Profile/PageHeaderTitle";

class EditProfile extends React.Component {
  render() {
    const { classes } = this.props;
    const { t } = this.props;
    return (
      <section className="edit_profile_form">
        <PageHeaderTitle
          title={t("profile.edit_profile_details")}
          className="edit_profile p-x-16"
          onClick={this.props.closeProfileScreen}
        />
        <Grid
          alignItems="center"
          className={classes.root}
          container
          justify="center"
          spacing={2}
        >
          <Grid
            alignItems="center"
            className={classes.root}
            item
            justify="center"
            sm={12}
            spacing={2}
            xs={12}
          >
            <Paper className={classes.paper}>
              <Card className={classes.root} variant="outlined">
                {/* <Button
									onClick={this.props.closeProfileScreen}
									size="small"
									style={{ display: 'inline-block', float: 'left' }}>
									<ArrowBackIosIcon />
									{t('buttons.back_profile')}
								</Button> */}
                <Grid
                  alignItems="center"
                  className={classes.root}
                  container
                  justify="center"
                  spacing={2}
                >
                  <Grid
                    alignItems="center"
                    item
                    justify="center"
                    sm={12}
                    xs={12}
                  >
                    <Grid
                      alignItems="center"
                      className={classes.root}
                      container
                      justify="center"
                    >
                      {this.props.children}
                    </Grid>
                    {/* <div className={classes.blockdiv}>
                      <Fab
                        aria-label="add"
                        className={classes.submit}
                        color="primary"
                        disabled={this.props.disabled}
                        onClick={this.props.onSubmitHandler}
                        size="medium"
                        type="submit"
                        variant="extended"
                      >
                        {t("buttons.save_changes")} &nbsp;
                      </Fab>
                    </div> */}
                  </Grid>
                  <Grid
                    alignItems="center"
                    item
                    justify="center"
                    sm={8}
                    xs={12}
                  >
                    <MobileFooter
                      className="mt-140 edit_profile_footer"
                      hasNext={true}
                      onClick={this.props.closeProfileScreen}
                      onSubmit={this.props.onSubmitHandler}
                    />
                  </Grid>
                </Grid>
              </Card>
            </Paper>
          </Grid>
        </Grid>
        {this.props.isLoading ? <Loader /> : ""}
      </section>
    );
  }
}

export default withStyles(commonStyleForEditPersonalInfo)(
  withTranslation()(EditProfile)
);
